import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Reserve an OpenShift Cluster (IBMers and IBM Partners only)`}</h2>
    <p>{`IBMers and Partners can get a temporary cluster from `}<a parentName="p" {...{
        "href": "https://techzone.ibm.com/collection/tech-zone-certified-base-images"
      }}><strong parentName="a">{`Techzone`}</strong></a>{`.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`VMWare on IBM Cloud Environments`}</inlineCode>{` in the left menu`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`OpenShift Cluster (VMware on IBM Cloud) - UPI - Public`}</inlineCode>{` or `}<inlineCode parentName="p">{`OpenShift Cluster (VMware on IBM Cloud) - IPI - Public`}</inlineCode>{` you want to use`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Reserve Now`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create a cluster for `}<inlineCode parentName="p">{`Practice/Self Education`}</inlineCode>{` if you don’t have an Opportunity Number`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select your preferred Geograpy`}</p>
        <img parentName="li" {...{
          "src": "./../images/roks01.png",
          "alt": "K8s CNI"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the maximum end date that fits your needs (you can extend the duration once after creation)`}</p>
        <img parentName="li" {...{
          "src": "./../images/roks03.png",
          "alt": "K8s CNI"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Make sure you select Openshift Parameters (don’t touch the other ones)`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`OpenShift Version: `}<strong parentName="p">{`4.12`}</strong></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Storage: OCS/ODF Size: `}<strong parentName="p">{`ODF - 5 TB`}</strong>{` or `}<strong parentName="p">{`Managed NFS - 2 TB`}</strong></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Worker node count: `}<strong parentName="p">{`5`}</strong></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Flavour: `}<strong parentName="p">{`32 vCPU X 128 GB`}</strong>{` ❗ `}</p>
          </li>
        </ul>
        <blockquote parentName="li">
          <p parentName="blockquote">{`❗ If you want to install CP4AIOps, Turbonomic and/or Instana please select `}<strong parentName="p">{`32 vCPU X 128 GB`}</strong>{` `}</p>
        </blockquote>
      </li>
    </ol>
    <ol>
      <li parentName="ol">{`Click `}<inlineCode parentName="li">{`Submit`}</inlineCode></li>
      <li parentName="ol">{`Once the cluster is provisioned, don’t forget to extend it to 8 days if needed.`}</li>
    </ol>
    <InlineNotification kind="info" mdxType="InlineNotification">
      <p><strong parentName="p">{`Other types of environment`}</strong></p>
      <p>{`You can also use classic ROKS Clusters, depending on the degree of control you need over your Cluster.`}</p>
    </InlineNotification> 

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      